import React from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import InfoIcon from './shared/info-icon';
import {displayQty, parseQtyInput} from './qty-parse/qty-parse';

const QtyComponent: React.FC = observer(() => {
    const [draft, setDraft] = React.useState<string | null>(null);

    const save = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value;
        const next = parseQtyInput(raw);
        if (next === null) {
            setDraft(raw);
            return;
        }
        s.ps.qty = next;
        setDraft(null);
    };

    const commitDraft = () => {
        if (draft !== null) {
            const next = parseQtyInput(draft);
            s.ps.qty = next ?? displayQty(s.ps.qty);
        }
        setDraft(null);
    };

    if (!s.ready || !s.ui.show_cust) {
        return null;
    }

    return (
        <div className="gray-box">
            <ModalSimple
                id="modal-qty"
                title="Volume Discount Information"
            >
                <div className="modal-qty-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Order Quantity</th>
                                <th>Discount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {s.si &&
                                s.si.VolumeDiscounts &&
                                s.si.VolumeDiscounts?.map(i => (
                                    <tr key={`${i.QtyMin}-${i.QtyMax}`}>
                                        <td>
                                            {i.QtyMin}-{i.QtyMax}
                                        </td>
                                        <td>{i.DiscountPercent}%</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </ModalSimple>

            <div style={{display: 'flex', gap: 5}}>
                <span className="header-std">Quantity</span>
                <div
                    className="info"
                    style={{minWidth: 110}}
                >
                    {(s.si?.VolumeDiscounts?.length ?? 0) > 0 && (
                        <InfoIcon
                            id="modal-qty"
                            ariaLabel="Open information about volume discount for this product"
                            styleBlack={true}
                        />
                    )}
                </div>
            </div>
            <input
                type="number"
                className="form-control ib input-qty"
                style={{width: 125}}
                value={draft !== null ? draft : String(displayQty(s.ps.qty))}
                onChange={save}
                onBlur={commitDraft}
                max={50000}
                min={1}
                aria-label="Enter quantity"
            />
        </div>
    );
});

export default QtyComponent;
